module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-gray@2x-f997d196a6b8cb04465ff6fdc77318c5.png";